import { render, staticRenderFns } from "./PrizeDialog.vue?vue&type=template&id=4f938d27&scoped=true"
import script from "./PrizeDialog.vue?vue&type=script&lang=js"
export * from "./PrizeDialog.vue?vue&type=script&lang=js"
import style0 from "./PrizeDialog.vue?vue&type=style&index=0&id=4f938d27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f938d27",
  null
  
)

export default component.exports